import { Component } from 'react';
import { Icon, IconName, ListItem } from '@optimus-web/core';

interface Props {
    printer: $TSFixMe; // TODO: pt.instanceOf(Device)
    onClick: $TSFixMeFunction;
}

class PrinterLink extends Component<Props> {
    handleClick = () => this.props.onClick(this.props.printer.id);

    render() {
        return (
            <ListItem
                leftIcon={<Icon value={IconName.Print} />}
                primaryText={this.props.printer.name}
                onClick={this.handleClick}
            />
        );
    }
}

export default PrinterLink;
